export default class HttpException extends Error {
    constructor(
        message: string|undefined,
        public code?: string|undefined,
    ) {
        super(message);
        this.name = 'HttpException';
    }
}
